import { render, staticRenderFns } from "./AskingStickersPage.vue?vue&type=template&id=535e7428&"
import script from "./AskingStickersPage.vue?vue&type=script&lang=js&"
export * from "./AskingStickersPage.vue?vue&type=script&lang=js&"
import style0 from "./AskingStickersPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports